import { Api } from "./Api";


let TimestampApi = {
    endpoint: "Timestamps/",
}

//Add the Api Mixin
TimestampApi = Object.assign({}, Api, TimestampApi);

export { TimestampApi };

